/**
 * Compile-time-only assertions used by `/constants` enum files to keep frontend enum
 * values pinned to the backend-generated string union types. Both functions are no-ops at
 * runtime; their entire purpose is to make a type mismatch a build failure.
 */

/**
 * Asserts that the frontend enum's value union (`Frontend`) and the backend-generated
 * string union (`Backend`) are exactly equal. Fails compilation if either side has a value
 * the other doesn't — the error names the missing/extra members in the call signature.
 */
export function pinEnum<Frontend extends string, Backend extends string>(
  ..._proof: Exclude<Frontend, Backend> extends never
    ? Exclude<Backend, Frontend> extends never
      ? []
      : [missingInFrontend: Exclude<Backend, Frontend>]
    : [extraInFrontend: Exclude<Frontend, Backend>]
  // oxlint-disable-next-line no-empty-function
): void {}

/**
 * Asserts that the frontend enum's value union is a subset of the backend-generated
 * string union — i.e., the backend may carry extra values the frontend deliberately
 * doesn't surface, but the frontend must not invent values the backend doesn't know.
 */
export function pinEnumSubset<Subset extends string, Superset extends string>(
  ..._proof: Exclude<Subset, Superset> extends never
    ? []
    : [notInBackend: Exclude<Subset, Superset>]
  // oxlint-disable-next-line no-empty-function
): void {}
